import { useState } from 'react';
import { hanumanJi } from '../assets/images';

export default function HanumanHero({ size = 'medium' }) {
  const [imgLoaded, setImgLoaded] = useState(false);

  const dim = size === 'large' ? 120 : size === 'small' ? 80 : 88;

  return (
    <div className="hanuman-hero-wrap" style={{ width: dim, height: dim }}>
      <div className="hanuman-aura" />
      {hanumanJi ? (
        <img
          src={hanumanJi}
          alt="हनुमान जी"
          className={`hanuman-hero-img ${imgLoaded ? 'loaded' : ''}`}
          style={{ width: dim, height: dim, objectFit: 'contain' }}
          onLoad={() => setImgLoaded(true)}
          onError={() => setImgLoaded(false)}
        />
      ) : (
        <div
          className="hanuman-hero-fallback"
          style={{ fontSize: dim * 0.75, lineHeight: 1 }}
          aria-label="हनुमान जी"
        >
          🐵
        </div>
      )}
    </div>
  );
}
